import { ConfigReportComboApi } from "go-report-combo/User/services/types";

export const REPORT_dayofweek_two_group_organizations = {
	id: "REPORT_dayofweek_two_group_organizations",
	name: "Raport dzień tygodnia dla dwóch grup lokaliacji",
	variables: [
		{
			id: "food_organization_ids",
		},
		{
			id: "bar_organization_ids",
		},
		{
			id: "date_range",
			type: "WEEK",
		},
		{
			id: "date_range_previous_week",
			type: "DYNAMIC",
			calculate: {
				variable_id: "date_range",
				method: "previous_weeks",
				value: 1,
			},
		},
		{
			id: "date_range_last_year_week",
			type: "DYNAMIC",
			calculate: {
				variable_id: "date_range",
				method: "previous_week_by_years",
				value: 1,
			},
		},
	],
	data: [
		{
			id: "BILLS",
			resource: "BILL",
			filter: "type=orderçorganization_id|e={food_organization_ids}",
			groups: ["NONE", "DAY_OF_WEEK"],
			columns: [
				{
					id: "summary",
					filter: "date_range|bt={date_range}",
				},
			],
		},
		{
			id: "BILLS_LW",
			resource: "BILL",
			filter: "type=orderçorganization_id|e={food_organization_ids}",
			groups: ["NONE", "DAY_OF_WEEK"],
			columns: [
				{
					id: "summary_lw",
					filter: "date_range|bt={date_range_previous_week}",
				},
			],
		},
		{
			id: "BILLS_LYW",
			resource: "BILL",
			filter: "type=orderçorganization_id|e={food_organization_ids}",
			groups: ["NONE", "DAY_OF_WEEK"],
			columns: [
				{
					id: "summary_lyw",
					filter: "date_range|bt={date_range_last_year_week}",
				},
			],
		},
		{
			id: "BILLS_BAR",
			resource: "BILL",
			filter: "type=orderçorganization_id|e={bar_organization_ids}",
			groups: ["NONE", "DAY_OF_WEEK"],
			columns: [
				{
					id: "summary",
					filter: "date_range|bt={date_range}",
				},
			],
		},
		{
			id: "BILLS_BAR_LW",
			resource: "BILL",
			filter: "type=orderçorganization_id|e={bar_organization_ids}",
			groups: ["NONE", "DAY_OF_WEEK"],
			columns: [
				{
					id: "summary_lw",
					filter: "date_range|bt={date_range_previous_week}",
				},
			],
		},
		{
			id: "BILLS_BAR_LYW",
			resource: "BILL",
			filter: "type=orderçorganization_id|e={bar_organization_ids}",
			groups: ["NONE", "DAY_OF_WEEK"],
			columns: [
				{
					id: "summary_lyw",
					filter: "date_range|bt={date_range_last_year_week}",
				},
			],
		},
	],
	table: [
		{
			id: "table2",
			rows: [
				{
					id: "food",
					type: "CALCULATE",
					data_ids: ["BILLS", "BILLS_LW", "BILLS_LYW"],
					group: "DAY_OF_WEEK",
					name: "Food",
					aggregate_columns: {
						revenue_this_week: "BILLS.net_total_money",
						revenue_last_week: "BILLS_LW.net_total_money",
						revenue_last_year: "BILLS_LYW.net_total_money",
					},
				},
				{
					id: "bar",
					type: "CALCULATE",
					data_ids: ["BILLS_BAR", "BILLS_BAR_LW", "BILLS_BAR_LYW"],
					group: "POINT_OF_SALE",
					name: "Bar",
					aggregate_columns: {
						revenue_this_week: "BILLS_BAR.net_total_money",
						revenue_last_week: "BILLS_BAR_LW.net_total_money",
						revenue_last_year: "BILLS_BAR_LYW.net_total_money",
					},
				},
			],
			columns: [
				{
					id: "revenue_this_week",
					data_column_id: "summary",
					name: "Revenue this week",
				},
				{
					id: "revenue_last_week",
					data_column_id: "summary_lw",
					name: "Revenue last week",
				},
				{
					id: "revenue_last_year",
					data_column_id: "summary_lyw",
					name: "Revenue last year",
				},
			],
		},
	],
} as ConfigReportComboApi;
